import { Stack, Typography } from "@mui/material"
import { isDefined } from "../../../../../../utils"
import { EvolutionStatChip } from "../../../../Chip"
import {
  AsideSectionSummaryMainSubTitle,
  type AsideSectionSummaryMainSubTitleProps,
} from "../common"

export type AsideSectionSummaryMainEvolutionProps = {
  label?: string
  kpi?: string | number | null
  evolution?: number | null
} & AsideSectionSummaryMainSubTitleProps

export const AsideSectionSummaryMainEvolution = (
  props: AsideSectionSummaryMainEvolutionProps,
) => (
  <Stack>
    <AsideSectionSummaryMainSubTitle {...props}>
      {props.label}
    </AsideSectionSummaryMainSubTitle>
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={1.5}
    >
      <Typography variant="29px" fontWeight={600} color="primary.dark1">
        {isDefined(props.kpi) ? props.kpi : "-"}
      </Typography>
      {isDefined(props.evolution) && (
        <Typography variant="18px">
          <EvolutionStatChip evol={props.evolution} arrow bold border={false} />
        </Typography>
      )}
    </Stack>
  </Stack>
)
